import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, Typography, Grid, Button } from '@mui/material';
import useTypewriter from '../components/Design/Typewriter';

import useMediaQuery from '@mui/material/useMediaQuery';
import LpStepperPc from '../components/Design/LpStepperPC';
import LpStepperSP from '../components/Design/LpStepperSP';


const plans = [
  { title: 'フリー', price: '0', features: ['広告あり', '1日3回', 'GPT4-0'] },
  { title: 'スタンダード', price: '490', features: ['広告なし', '1日5回', 'GPT4-0'] },
  { title: 'プレミアム', price: '990', features: ['広告なし', '1日10回', 'GPT4-0'] },
];

function Lp() {

  const texts = [
    "韓国語専用AIツールが、あなたの文章を最速かつ正確に添削",
    "人間の添削では、実現できない、文法や表現のミスを瞬時に指摘",
    "あなたの韓国語学習を、手助けする最適なAIツール"
  ];
  const typedText = useTypewriter(texts, 150);

  const matches = useMediaQuery('(min-width:600px)'); // 600pxは例です

  return (
    <>
      <div className="lpContainer">
        <div className="lpMain">
          <div className="typeArea">
            {typedText}
          </div>
          <img src="/images/lp1.png" alt="説明" />
        </div>
        <div className="lpStepper">
          <h2 style={{ textAlign: 'center' }}>ハングルマッチAIの使い方</h2>
          <div className="stepper">
            {matches ? <LpStepperPc /> : <LpStepperSP />}
          </div>
        </div>
        <div className="lpPricing">
          <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>料金プラン</h2>
          <div className="priceListArea">
            {plans.map((plan) => (
              <Card variant="outlined" key={plan.title} style={{ marginBottom: 20 }}>
                <CardContent>
                  <Typography variant="h5" component="h2">
                    {plan.title}
                  </Typography>
                  <Typography variant="h4">
                    ¥{plan.price}円
                  </Typography>
                  <hr style={{ margin: '10px 0px' }} className='hr' />
                  <ul>
                    {plan.features.map((feature) => (
                      <li key={feature}>
                        <Typography variant="body1">{feature}</Typography>
                      </li>
                    ))}
                  </ul>
                  <Button
                    variant="contained"
                    component={Link}
                    to="/login"
                    style={{ width: '100%', background: '#21D65F', fontWeight: 'bold' }}>
                    申し込む
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Lp;